import { memo } from 'react'
import { GalleryImageItem } from '@/components/commons/gallery-image-item'
import { ButtonLegacy } from '@/components/ui/button-legacy'
import { Flexbox } from '@/components/ui/flexbox'
import { Expand01Icon, ThumbsUpIcon } from '@/components/ui/icons'
import {
	OpsVettingGalleryItemsContainer,
	OpsVettingImageTitle
} from '@/features/ops-vetting/components/ops-vetting-atoms'
import { useUpdateIsApprovedGalleryImg } from '@/features/service-vetting/query/use-update-is-approved-gallery-img.ts'
import type { ServiceGalleryImage } from '@/features/service-vetting/types.ts'
import { useTranslation } from '@/translations/i18n'
import { ServiceVettingGalleryImageRejectDialog } from './service-vetting-gallery-image-reject-dialog'

export const ServiceVettingCriteriaGalleryItem = memo(
	({
		image,
		galleryId,
		hideAction,
		onClickExpand,
		serviceId
	}: {
		image: ServiceGalleryImage
		galleryId: number
		hideAction?: boolean
		serviceId: number
		onClickExpand?: (image: ServiceGalleryImage) => void
	}) => {
		const { t } = useTranslation()

		const updateIsApprovedGalleryImg = useUpdateIsApprovedGalleryImg({
			serviceId,
			imgId: image.id,
			galleryId
		})

		return (
			<OpsVettingGalleryItemsContainer direction='column' gap={4}>
				<GalleryImageItem
					bottomRightSlot={
						!hideAction && (
							<ButtonLegacy
								className='show-on-hover'
								onClick={() => onClickExpand?.(image)}
								shape='square'
								size='sm'
								type='button'
								variant='secondary'
							>
								<Expand01Icon />
							</ButtonLegacy>
						)
					}
					src={image.thumbnails?.xs || image.url}
				/>
				<Flexbox direction='column' fullWidth gap={2}>
					<OpsVettingImageTitle>{image.name}</OpsVettingImageTitle>
					<Flexbox fullWidth gap={3}>
						<ButtonLegacy
							className='w-full'
							disabled={hideAction}
							onClick={() =>
								image.is_approved !== true &&
								updateIsApprovedGalleryImg.mutate({
									is_approved: true
								})
							}
							size={'sm'}
							type='button'
							variant={
								image.is_approved === null || !image.is_approved
									? 'secondary'
									: 'primarySuccess'
							}
						>
							<ThumbsUpIcon />
							{t('vetting:criteria.service.gallery.accept')}
						</ButtonLegacy>
						<ServiceVettingGalleryImageRejectDialog
							currentFlags={image.flags}
							disabled={hideAction}
							galleryId={galleryId}
							image={image}
							serviceId={serviceId}
						/>
					</Flexbox>
				</Flexbox>
			</OpsVettingGalleryItemsContainer>
		)
	}
)
